import { t } from "@/i18n-js/instance";
import { ListingCard } from "../ListingCard";

interface SpaceGroupListCardProps {
  resources: Array<{ name: string; id: string }>;
}

export const SpaceGroupListCard = ({ resources }: SpaceGroupListCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.space_groups")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_space_groups_found")}
    renderItem={spaceGroup => (
      <span className="font-bold">{spaceGroup.name}</span>
    )}
    getItemKey={spaceGroup => spaceGroup.id}
  />
);
